export default __webpack_public_path__ + "static/media/Nozzle, White.7a7f7ac5.png";